import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { DataService } from 'src/app/services/data.service';
import { IActivity, IVocabulary } from 'src/app/interfaces/resource';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService, pushObjArray } from 'src/app/services/convert.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { Observable } from 'rxjs';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-key-vocabulary-definition',
  templateUrl: './add-key-vocabulary-definition.component.html',
  styleUrls: ['./add-key-vocabulary-definition.component.scss']
})
export class AddKeyVocabularyDefinitionComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  TITLE = "Create more definition"
 @ViewChild('pictureFile',{static:false}) pictureFile: ElementRef;
  @ViewChild('soundFile', { static: false }) soundFile: ElementRef;

  form: FormGroup;
  pos: AbstractControl;
  definition: AbstractControl;
  synonyms: AbstractControl;
  examples: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;

  SELECTED_PICTURE_FILE: any;
  SELECTED_SOUND_FILE: any;
  uploadPercentPicture: Observable<number>
  uploadPercentSound: Observable<number>
  START_UPLOAD: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddKeyVocabularyDefinitionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: ActivityStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private storage: FireStorageService,
    private route: Router
  ) { }

  ngOnInit() {
    const { QUESTION } = this.data;
    this.form = this.fb.group({
      pos: [QUESTION ? QUESTION.pos : null, Validators.compose([Validators.required])],
      definition: [QUESTION ? QUESTION.definition : null, Validators.required],
      synonyms: [QUESTION ? QUESTION.synonyms : null],
      examples: [QUESTION ? QUESTION.examples : null],
    })
    if (QUESTION) {
      this.TITLE = "Edit definition";
    }
  }

  async uploadFilePicture(event) {
    this.SELECTED_PICTURE_FILE = event;
    const { MODULE_KEY, ITEM, QUESTION } = this.data;
    if (QUESTION) {
      //PICTURE
      this.START_UPLOAD = true;
      const fileName = event.target.files[0].name;
      const picturePath = `${MODULE_KEY}/${ITEM.key}/picture/${fileName}`;
      const pictureTask = this.storage.uploadFile(this.SELECTED_PICTURE_FILE, picturePath);
      this.uploadPercentPicture = pictureTask.percentageChanges();
      const downloadURLPicture = (await pictureTask).ref.getDownloadURL();
      downloadURLPicture.then(downloadURL => {
        const QUESTION_DATA = {
          ...QUESTION,
          pictureDownloadURL: downloadURL
        }
        this.store.updateWordsDownloadURL(ITEM, QUESTION_DATA, (success, res) => {
          this.data.ITEM.pictureDownloadURL = downloadURL;
          this.snackBar.open("Picture has been uploaded successful.", "Done", { duration: 1000 });
          this.START_UPLOAD = false;
          this.pictureFile.nativeElement.value = ""
        })
      })
    }
  }

  async uploadFileSound(event) {
    this.SELECTED_SOUND_FILE = event;
    const { MODULE_KEY, ITEM, QUESTION } = this.data;
    if (QUESTION) {
      //SOUND
      this.START_UPLOAD = true;
      const fileName = event.target.files[0].name;
      const picturePath = `${MODULE_KEY}/${ITEM.key}/picture/${fileName}`;
      const pictureTask = this.storage.uploadFile(this.SELECTED_SOUND_FILE, picturePath);
      this.uploadPercentPicture = pictureTask.percentageChanges();
      const downloadURLPicture = (await pictureTask).ref.getDownloadURL();
      downloadURLPicture.then(downloadURL => {
        const QUESTION_DATA = {
          ...QUESTION,
          soundDownloadURL: downloadURL
        }
        this.store.updateWordsDownloadURL(ITEM, QUESTION_DATA, (success, res) => {
          this.data.ITEM.soundDownloadURL = downloadURL;
          this.snackBar.open("Sound has been uploaded successful.", "Done", { duration: 1000 });
          this.START_UPLOAD = false;
          this.soundFile.nativeElement.value = ""
        })
      })
    }
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    const { FORM, SKILL, ACTIVITY_TYPE, MODULE_KEY, ITEM, QUESTION, ACTIVITY_TYPE_OBJECT, SKILL_NAME } = this.data;
    if ((!this.SELECTED_PICTURE_FILE || !this.SELECTED_SOUND_FILE) && !QUESTION) {
      alert('Please select picture file or sound file');
      return;
    }
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { word, phonetic, pos, synonyms, examples, definition } = f;
      this.START_UPLOAD = true;
      const key = ITEM ? ITEM.key : this.ds.createId();
      const wordKey = this.ds.createId();
      if (!QUESTION) {//NEW VOCABULARY
        //PICTURE
        const fileName = this.SELECTED_PICTURE_FILE.target.files[0].name
        const picturePath = `${MODULE_KEY}/${key}/picture/${fileName}`;
        const pictureTask = this.storage.uploadFile(this.SELECTED_PICTURE_FILE, picturePath);
        this.uploadPercentPicture = pictureTask.percentageChanges();
        const downloadURLPicture = (await pictureTask).ref.getDownloadURL();
        //SOUND
        const soundFileName = this.SELECTED_SOUND_FILE.target.files[0].name
        const soundPath = `${MODULE_KEY}/${key}/sound/${soundFileName}`;
        const soundTask = this.storage.uploadFile(this.SELECTED_SOUND_FILE, soundPath);
        this.uploadPercentSound = soundTask.percentageChanges();
        const downloadURLSound = (await soundTask).ref.getDownloadURL();

        const { name, instruction, defaultInstruction } = FORM;
        const { user, selectedCompanyKey } = this.auth;
        const { words } = ITEM;
        const registerStatus = STATUS_OBJECT.submitted;
        downloadURLPicture.then(pictureUrl => {
          downloadURLSound.then(soundUrl => {
            const wordData: IVocabulary = {
              word: `${word}`.trim(),
              key: wordKey,
              phonetic: phonetic,
              pictureDownloadURL: pictureUrl,
              soundDownloadURL: soundUrl,
              pos: pos || null,
              synonyms: synonyms || null,
              examples: examples || null,
              definition: definition || null,
            };
            const WORDS_DATA = pushObjArray(words, wordData)
            const activity: IActivity = {
              key: key,
              status: DISPLAY_STATUS_OBJECT.ACTIVE,
              isDelete: false,
              created_at: ITEM ? ITEM.created_at : new Date(),
              created_by: ITEM ? ITEM.created_by : user.uid,
              updated_at: new Date(),
              updated_by: user.uid,
              date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
              page_key: ConvertService.pageKey(),
              keyword: null,
              organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
              organizationKey: selectedCompanyKey,
              created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
              updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
              register_status: registerStatus,
              //fields
              name: name || null,
              instruction: instruction || null,
              defaultInstruction: defaultInstruction || false,
              words: WORDS_DATA,
              hasSubActivity: false,
              //module
              skillKey: SKILL,
              skillRef: this.ds.skillRef().doc(SKILL).ref,
              skillName:SKILL_NAME,
              activityTypeKey: ACTIVITY_TYPE,
              activityTypeRef: this.ds.activityTypeRef().doc(ACTIVITY_TYPE).ref,
              activityTypeName: ACTIVITY_TYPE_OBJECT.name,
              moduleKey: MODULE_KEY,
              moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(MODULE_KEY).ref,
            }
            this.store.addItem(activity, this.data.MODULE, true, (success, res) => {
              this.data.ITEM = activity;
              this.snackBar.open("Activity has been saved successful.", "Done", { duration: 1000 });
              if (!isNew) {
                this.route.navigate([`/modules/activity-type/key_vocabulary/${SKILL}/${MODULE_KEY}/${activity.key}`])
                this.dialogRef.close('no')
                return;
              }
              this.form.reset();
              this.form.enable();
              this.form.patchValue({ isFill: false })
              this.processNew = false;
              this.processClose = false;
              this.SELECTED_PICTURE_FILE = null;
              this.SELECTED_SOUND_FILE = null;
              this.START_UPLOAD = false;
              this.isCreate = false;
              this.inputEl.nativeElement.focus()
              this.pictureFile.nativeElement.value = "";
              this.soundFile.nativeElement.value = "";
              this.route.navigate([`/modules/activity-type/key_vocabulary/${SKILL}/${MODULE_KEY}/${activity.key}`])
            })
          })
        })
      }


    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}